import {
  AdminSwitch,
  ChevronSmall,
  Div,
  H5,
  Icon,
  Img,
  TooltipWrapper,
  VDriveProviderInfo,
  plate,
  renderProviderIcon,
  renderProviderName,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import { Collapsible } from './VDriveLocation';

export const ProvidersVDrive = ({
  providers,
  setProviders,
  disabled,
}: {
  providers: VDriveProviderInfo[];
  setProviders: Dispatch<SetStateAction<VDriveProviderInfo[]>>;
  disabled?: boolean;
}) => {
  const [providersCollapse, setProvidersCollapse] = useState(false);
  const refProviders = useRef<HTMLDivElement>(null);
  const elementHeightProviders = refProviders?.current?.clientHeight;

  const handleProviderCollapse = () => {
    // if (disabled) return ErrorToast(message);
    setProvidersCollapse((prev) => !prev);
  };

  const message =
    'Providers can be edited once vDrive request for this store is submitted and approved. While vDrive is active for vOrders setup only, provider changes are temporarily locked.';

  return (
    <TooltipWrapper tooltip={disabled ? message : undefined} $width="100%">
      <Div $box $p="24px">
        {/* Faded inside the card, not on it: opacity below 1 lifts the card into
            its own layer and its shadow then paints over the card below. */}
        <Div $flex $column $opacity={disabled ? '0.5' : '1'}>
          <Div
            $pointer={!disabled}
            $flex
            $alignCenter
            $between
            onClick={handleProviderCollapse}
            $notAllowed={disabled}
          >
            <H5 $mb="0">Providers</H5>
            <Icon $rotate={providersCollapse ? '180deg' : '0'}>
              <ChevronSmall />
            </Icon>
          </Div>
          <Collapsible
            expanded={providersCollapse}
            elementHeight={elementHeightProviders}
          >
            <Div ref={refProviders} $flex $column $gap="16px">
              {providers.map(({ provider, enabled }, i) => (
                <Div key={i} $flex $between $alignCenter>
                  <Div $flex $alignCenter $gap="20px">
                    <Img
                      alt=""
                      width="32px"
                      src={renderProviderIcon(provider, plate)}
                    />
                    <H5 $m="0">{renderProviderName(provider, provider)}</H5>
                  </Div>
                  <AdminSwitch
                    checked={enabled}
                    onChange={() =>
                      setProviders((prev) =>
                        prev.map((p) => {
                          if (p.provider === provider) {
                            return { provider, enabled: !p.enabled };
                          } else return p;
                        })
                      )
                    }
                  />
                </Div>
              ))}
            </Div>
          </Collapsible>
        </Div>
      </Div>
    </TooltipWrapper>
  );
};
